import { render, staticRenderFns } from "./StructureViewer.vue?vue&type=template&id=8d10d142&scoped=true&"
import script from "./StructureViewer.vue?vue&type=script&lang=js&"
export * from "./StructureViewer.vue?vue&type=script&lang=js&"
import style0 from "./StructureViewer.vue?vue&type=style&index=0&id=8d10d142&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d10d142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VItemGroup,VTooltip})
